import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { navigate } from 'gatsby';
import { connect } from 'react-redux';
import { makeStyles, Button } from '@material-ui/core';

import Tab from 'src/components/tab';
import MaterialTable from 'src/components/materialTable';

import { setTabExpend } from './slice';

const useStyles = makeStyles(theme => ({
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
    },
  },
}));

const ParkedCalls = props => {
  const { isTabExpended } = props;
  const classes = useStyles();

  const prismicContent = useStaticQuery(graphql`
    query {
      allPrismicOverview {
        edges {
          node {
            data {
              title9 {
                html
                text
                raw
              }
            }
          }
        }
      }
    }
  `);

  const prismicData = prismicContent.allPrismicOverview.edges[0].node.data;

  const [state, setState] = React.useState({
    columns: [
      { title: 'Id', field: 'id', hidden: true },
      { title: 'Lead Name', field: 'name', cellStyle: { fontWeight: 600 } },
      { title: 'Lead Number', field: 'phone' },
      { title: 'Routing Rule', field: 'routing' },
      { title: 'Next Call', field: 'nextcall' },
      { title: 'After Hour Lead', field: 'afterhours', width: 200 },
      { title: 'Attempt Number', field: 'attempt', width: 200 },
    ],
    data: [
      {
        id: 1,
        name: 'Tiana Stephens',
        phone: '14242987668',
        routing: 'EST',
        nextcall: '2020-07-13 3:33.23 PM',
        afterhours: 'Yes',
        attempt: '2',
      },
      {
        id: 1,
        name: 'Tiana Stephens',
        phone: '14242987668',
        routing: 'EST',
        nextcall: '2020-07-13 3:33.23 PM',
        afterhours: 'Yes',
        attempt: '2',
      },
      {
        id: 1,
        name: 'Tiana Stephens',
        phone: '14242987668',
        routing: 'EST',
        nextcall: '2020-07-13 3:33.23 PM',
        afterhours: 'Yes',
        attempt: '2',
      },
    ],
  });

  const handelExpand = () => {
    props.setTabExpend(!isTabExpended);
  };

  return (
    <>
      <Tab title={prismicData.title9.text} drag onClick={handelExpand} expanded={isTabExpended} disablePadding>
        <MaterialTable
          columns={state.columns}
          data={state.data}
          options={{
            headerStyle: {
              // paddingLeft: 35,
            },
            cellStyle: {
              // paddingLeft: 35,
            },
          }}
          localization={{
            header: {
              actions: '',
            },
          }}
          editable={{
            onRowDelete: oldData =>
              new Promise(resolve => {
                setTimeout(() => {
                  resolve();
                  setState(prevState => {
                    const data = [...prevState.data];
                    data.splice(data.indexOf(oldData), 1);
                    return { ...prevState, data };
                  });
                }, 600);
              }),
          }}
        />
      </Tab>
      <div className={classes.buttonWrapper}>
        <Button
          variant="contained"
          color="secondary"
          size="large"
          disableElevation
          onClick={() => {
            navigate('/me/parked-calls/');
          }}
        >
          View all Parked calls
        </Button>
      </div>
    </>
  );
};

const mapStateToProps = ({ me }) => {
  const { overview } = me;
  const { parkedCalls } = overview;
  return { ...parkedCalls };
};

const mapDispatchToProps = { setTabExpend };

export default connect(mapStateToProps, mapDispatchToProps)(React.memo(ParkedCalls));
